import { render, staticRenderFns } from "./headerComposeDoc.vue?vue&type=template&id=04d84cb0&scoped=true&"
import script from "./headerComposeDoc.vue?vue&type=script&lang=js&"
export * from "./headerComposeDoc.vue?vue&type=script&lang=js&"
import style0 from "./headerComposeDoc.vue?vue&type=style&index=0&id=04d84cb0&lang=scss&scoped=true&"
import style1 from "./headerComposeDoc.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d84cb0",
  null
  
)

export default component.exports